import { passkeyClient } from "@better-auth/passkey/client";
import { twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

/**
 * Better Auth browser client (TW-3431). With no baseURL it targets the current origin
 * and Better Auth's default `/api/auth` basePath — in dev the Vite server proxies
 * `/api` → the API container, so login is same-origin from the browser's perspective.
 *
 * TW-3455 adds the second-factor plugins, matching the server (auth.ts):
 *   • twoFactorClient — exposes authClient.twoFactor.{enable,verifyTotp,disable,…}. When a
 *     2FA-enrolled user signs in, signIn.email resolves with `{ data: { twoFactorRedirect:
 *     true } }` instead of a session; the login page reads that flag to show the TOTP step.
 *   • passkeyClient — exposes authClient.passkey.{addPasskey,listUserPasskeys,deletePasskey}
 *     and signIn.passkey() for WebAuthn registration, management and sign-in.
 */
export const authClient = createAuthClient({
  plugins: [twoFactorClient(), passkeyClient()],
});

export const { signIn, signOut, useSession, getSession, twoFactor, passkey } = authClient;
